/** AUTO-GENERATED — do not edit. Run: yarn sync:amp-registry */
export const AMP_TRACK_CONTEXT_DEFAULT = 'dashboard-team';

export const AMP_TRACK_CONTEXT_REGISTRY = [
  { pathPrefix: '/upgrade/software-cost-insights', context: 'upsell-software-cost-insights' },
  { pathPrefix: '/upgrade/productivity-ratings', context: 'upsell-productivity-ratings' },
  { pathPrefix: '/upgrade/dashboard-executive', context: 'upsell-dashboard-executive' },
  { pathPrefix: '/upgrade/unusual-activity', context: 'upsell-unusual-activity' },
  { pathPrefix: '/upgrade/meeting-insights', context: 'upsell-meeting-insights' },
  { pathPrefix: '/upgrade/office-vs-remote', context: 'upsell-office-vs-remote' },
  { pathPrefix: '/upgrade/activity-summary', context: 'upsell-activity-summary' },
  { pathPrefix: '/upgrade/internet-report', context: 'upsell-internet-connectivity' },
  { pathPrefix: '/software-cost-insights', context: 'software-cost-insights' },
  { pathPrefix: '/upgrade/web-app-usage', context: 'upsell-web-app-usage' },
  { pathPrefix: '/productivity-ratings', context: 'productivity-ratings' },
  { pathPrefix: '/dashboard-individual', context: 'dashboard-individual' },
  { pathPrefix: '/dashboard-executive', context: 'dashboard-executive' },
  { pathPrefix: '/upgrade/screencasts', context: 'upsell-screencasts' },
  { pathPrefix: '/projects-and-tasks', context: 'settings-project-task' },
  { pathPrefix: '/manage-user-groups', context: 'groups' },
  { pathPrefix: '/upgrade/benchmarks', context: 'upsell-benchmarks' },
  { pathPrefix: '/upgrade/attendance', context: 'upsell-attendance' },
  { pathPrefix: '/compliance-doctor', context: 'compliance-doctor' },
  { pathPrefix: '/upgrade/schedules', context: 'upsell-schedules' },
  { pathPrefix: '/upgrade/approvals', context: 'upsell-approvals' },
  { pathPrefix: '/activity-summary', context: 'activity-summary' },
  { pathPrefix: '/meeting-insights', context: 'meeting-insights' },
  { pathPrefix: '/office-vs-remote', context: 'office-vs-remote' },
  { pathPrefix: '/unusual-activity', context: 'unusual-activity' },
  { pathPrefix: '/setup/attendance', context: 'setup-attendance' },
  { pathPrefix: '/internet-report', context: 'internet-connectivity' },
  { pathPrefix: '/projects-report', context: 'projects-tasks' },
  { pathPrefix: '/upgrade/payroll', context: 'upsell-payroll' },
  { pathPrefix: '/ai-connections', context: 'ai-connections' },
  { pathPrefix: '/upgrade/breaks', context: 'upsell-breaks' },
  { pathPrefix: '/hours-tracked', context: 'hours-tracked' },
  { pathPrefix: '/web-app-usage', context: 'web-app-usage' },
  { pathPrefix: '/notifications', context: 'notifications' },
  { pathPrefix: '/add-managers', context: 'add-managers' },
  { pathPrefix: '/manage-users', context: 'users' },
  { pathPrefix: '/integrations', context: 'integrations' },
  { pathPrefix: '/company/edit', context: 'company-settings' },
  { pathPrefix: '/profile/edit', context: 'edit-profile' },
  { pathPrefix: '/profile-edit', context: 'edit-profile' },
  { pathPrefix: '/screencasts', context: 'screencasts' },
  { pathPrefix: '/new-billing', context: 'billing' },
  { pathPrefix: '/attendance', context: 'attendance' },
  { pathPrefix: '/benchmarks', context: 'benchmarks' },
  { pathPrefix: '/onboarding', context: 'onboarding' },
  { pathPrefix: '/ai-impact', context: 'ai-impact' },
  { pathPrefix: '/approvals', context: 'approvals' },
  { pathPrefix: '/downloads', context: 'download' },
  { pathPrefix: '/edit-time', context: 'edit-time' },
  { pathPrefix: '/schedules', context: 'schedules' },
  { pathPrefix: '/dashboard', context: 'dashboard-team' },
  { pathPrefix: '/timeline', context: 'timeline' },
  { pathPrefix: '/signals', context: 'insights' },
  { pathPrefix: '/billing', context: 'billing' },
  { pathPrefix: '/payroll', context: 'payroll' },
  { pathPrefix: '/company', context: 'company-settings' },
  { pathPrefix: '/invite', context: 'invite' },
  { pathPrefix: '/breaks', context: 'breaks' },
  { pathPrefix: '/csv', context: 'custom-export' },
] as const;

export const AMP_TRACK_CONTEXT_VALUES = new Set<string>([
  // Dashboard
  'dashboard-executive',
  'dashboard-individual',
  'dashboard-team',

  // Onboarding
  'onboarding',

  // Other Feature
  'add-managers',
  'approvals',
  'billing',
  'download',
  'edit-time',
  'invite',
  'payroll',

  // Report
  'activity-summary',
  'ai-impact',
  'attendance',
  'benchmarks',
  'compliance-doctor',
  'custom-export',
  'hours-tracked',
  'insights',
  'internet-connectivity',
  'meeting-insights',
  'office-vs-remote',
  'projects-tasks',
  'screencasts',
  'software-cost-insights',
  'timeline',
  'unusual-activity',
  'web-app-usage',

  // Settings
  'ai-connections',
  'breaks',
  'company-settings',
  'edit-profile',
  'groups',
  'integrations',
  'notifications',
  'productivity-ratings',
  'schedules',
  'settings-project-task',
  'users',

  // Setup Page
  'setup-attendance',

  // Upsell Page
  'upsell-activity-summary',
  'upsell-approvals',
  'upsell-attendance',
  'upsell-benchmarks',
  'upsell-breaks',
  'upsell-dashboard-executive',
  'upsell-internet-connectivity',
  'upsell-meeting-insights',
  'upsell-office-vs-remote',
  'upsell-payroll',
  'upsell-productivity-ratings',
  'upsell-schedules',
  'upsell-screencasts',
  'upsell-software-cost-insights',
  'upsell-unusual-activity',
  'upsell-web-app-usage',
]);
